import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { OwnerVIPDocument } from "@eres/vipownerapi/entities";

interface Props {
	documents: OwnerVIPDocument[];
	onDismiss: () => void;
}

interface State {

}

class RequestDocuments extends Component<Props, State> {
	render() {
		const { documents, onDismiss } = this.props;
		return <Popup
			id={ "RequestDocuments" } title={ Strings.documents } showIcon={ false }
			onDismiss={ onDismiss }>
			<ul className="list-group request-document">
				{ documents.map( ( document: OwnerVIPDocument, index: number ) => {
					return <li
						key={ `vip_req_doc_${ index }` }
						className="list-group-item d-flex justify-content-between align-items-center"
						onClick={ () => {
							window.open( document.DocumentPath );
						} }>{ document.DocumentName }
						<span>{ Strings.download }</span></li>;
				} ) }
			</ul>
		</Popup>;
	}
}

export default RequestDocuments;
